import { BookOpen, Phone, type LucideIcon } from "lucide-react";
import { buildNavUrl } from "@/hooks/useAuth";

type Page = "wins" | "calls" | "stories";

const TABS: { page: Page; label: string; icon?: LucideIcon }[] = [
  { page: "wins", label: "Wins" },
  { page: "calls", label: "Calls", icon: Phone },
  { page: "stories", label: "Lead Story", icon: BookOpen },
];

/** Page switcher shared by every felixwins.* surface. `dark` for navy headers. */
export function PageTabs({ active, dark = false, className = "" }: { active: Page; dark?: boolean; className?: string }) {
  const box = dark ? "border-white/20 bg-white/10" : "border-[hsl(var(--border))] bg-white";
  const on = dark ? "bg-white/20 text-white" : "bg-[hsl(var(--muted))] text-[hsl(var(--foreground))]";
  const off = dark ? "text-white/70 hover:text-white" : "text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]";
  return (
    <div className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-lg border p-0.5 text-[12px] ${box} ${className}`}>
      {TABS.map(({ page, label, icon: Icon }) => {
        const content = <>{Icon && <Icon className="w-3.5 h-3.5" />}{label}</>;
        return page === active ? (
          <span key={page} aria-current="page" className={`h-7 px-2.5 rounded-md inline-flex items-center gap-1 font-medium ${on}`}>
            {content}
          </span>
        ) : (
          <a key={page} href={buildNavUrl({ page: page === "wins" ? null : page })} className={`h-7 px-2.5 rounded-md inline-flex items-center gap-1 ${off}`}>
            {content}
          </a>
        );
      })}
    </div>
  );
}
